/* eslint-disable react-hooks/exhaustive-deps */
import {
  useNavigation,
  useFocusEffect,
  useIsFocused,
} from "@react-navigation/native";
import React, { useCallback, useMemo, useState } from "react";
import {
  ActivityIndicator,
  StyleSheet,
  View,
  TouchableNativeFeedback,
  SectionList,
} from "react-native";

import CustomText from "@components/CustomText";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import colors from "@constants/color";
import { getComboItems, submitComboItems } from "@services/api";
import CrateCard from "./CrateCard";

const ComboItems = ({ route }) => {
  const navigation = useNavigation();
  const isFocused = useIsFocused();
  const [isLoading, setIsLoading] = useState(true);
  const [comboItems, setComboItems] = useState({ data: [] });

  const info = route?.params?.info;

  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
    }, [isFocused]),
  );

  const fetchData = async () => {
    try {
      const { data } = await getComboItems({
        order_item_id: info?.order_item_id,
        item_number: info?.item_number,
      });
      setComboItems(data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async () => {
    try {
      await submitComboItems({
        order_item_id: info?.order_item_id,
        item_number: info?.item_number,
      });
      if (comboItems?.samasyaHai) {
        navigation.navigate("ComboReturn", {
          order_item_id: info?.order_item_id,
          item_number: info?.item_number,
          pop_back: 2,
        });
      } else {
        navigation.goBack();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderItem = useCallback(({ item }) => {
    return (
      <>
        <CrateCard info={item} fetchData={fetchData} />
        <View
          style={{
            backgroundColor: "rgba(244, 244, 244, 1)",
            height: 1,
            paddingHorizontal: 16,
          }}
        />
      </>
    );
  }, []);

  const footerComponent = () => (
    <View style={{ height: 240, backgroundColor: "white" }} />
  );

  const renderSection = () => {
    return (
      <View
        style={{
          marginLeft: 16,
          marginTop: 16,
          flexDirection: "row",
        }}
      >
        <View
          style={{
            backgroundColor: "rgba(103, 61, 193, 1)",
            paddingVertical: 3,
            paddingHorizontal: 8,
            borderRadius: 40,
          }}
        >
          <CustomText variant="title_16" style={{ color: "white" }}>
            कॉम्बो
          </CustomText>
        </View>
      </View>
    );
  };

  const sortUpdates = useMemo(() => {
    return comboItems?.data.map((v) => {
      return {
        ...v,
        data: v?.items,
      };
    });
  }, [comboItems]);

  const keyExtractor = (item, index) => `${index}`;

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle="आइटम्स देखें/ मार्क करें "
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      {isLoading ? (
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <View style={{ flex: 1, marginTop: 8, backgroundColor: "white" }}>
          <SectionList
            renderSectionHeader={renderSection}
            keyExtractor={keyExtractor}
            contentContainerStyle={{ marginTop: 8, paddingBottom: 60 }}
            sections={sortUpdates}
            renderItem={renderItem}
            keyboardShouldPersistTaps="handled"
            ListFooterComponent={footerComponent}
          />
          {comboItems?.showSubmitButton ? (
            <View
              style={{
                backgroundColor: "white",
                position: "absolute",
                bottom: 0,
                width: "100%",
                paddingHorizontal: 16,
              }}
            >
              <TouchableNativeFeedback
                testID="submit"
                onPress={() => onSubmit()}
              >
                <View
                  style={{
                    marginBottom: 10,
                    backgroundColor: "rgba(0, 171, 89, 1)",
                    paddingVertical: 10,
                    alignItems: "center",
                    borderRadius: 8,
                  }}
                >
                  <CustomText variant="title_16" style={{ color: "white" }}>
                    सबमिट करें
                  </CustomText>
                </View>
              </TouchableNativeFeedback>
            </View>
          ) : null}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
});

export default ComboItems;
